import CheckboxMui from '@mui/material/Checkbox'

const Checkbox = ({ sx, ...rest }: React.ComponentProps<typeof CheckboxMui>) => {
  return (
    // generate unit test to check if the checkbox is rendered with the correct sx props
    <CheckboxMui sx={{ p: '0', color: 'primary.lighter', ...sx }} color='secondary' {...rest} />
  )
}

export default Checkbox
